import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL =  getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

// Interceptor del token
api.interceptors.request.use(
  (config) => {
    const token = secureStorage.getItem("authToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/* ========================================================
   POST: Registrar faltas / permisos / ausencias
   ======================================================== */
export const postDatosFaltas = async (datos) => {
  try {
    const response = await api.post("faltas", datos);
    
    return response.data;
    
  } catch (error) {
    console.log("🚀 ~ postDatosFaltas ~ error:", error);
    if (error.response?.data?.message) {
      throw new Error("Error al enviar datos al backend: " + error.response.data.message);
      
    } else {
      throw new Error("Error al enviar datos al backend: " + error.message);
    }
  }
};

export const getFaltas = async () => {
  try {
    const response = await api.get('faltas'); // asegúrate que esta ruta existe en tu backend
    return response.data;
  } catch (error) {
    console.error('Error al obtener faltas:', error);
    throw error;
  }
};

export const getFaltasview = async () => {
  try {
    const response = await api.get('faltasview'); // asegúrate que esta ruta existe en tu backend
    return response.data;
  } catch (error) {
    console.error('Error al obtener faltas:', error);
    throw error;
  }
};

export const updateFaltas = async (id, data) => {
  try {
    const response = await api.put(`/faltas/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error('Error al enviar datos al backend: ', error);
  }
};